import Icon from '@material-ui/icons/People';
import List from './List';

export {
  Icon,
  List,
};



// WEBPACK FOOTER //
// ./src/components/NewAccounts/index.js